import { render } from "./AppFooterPhone.vue?vue&type=template&id=3dd2fcb0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__